<script setup>

import {computed, ref} from "vue";
import {Tab} from "@/base-components/Headless";
import Button from "@/base-components/Button";
import {useRoute, useRouter} from "vue-router";
import BaseDialog from "@/base-components/Dialog/BaseDialog.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  pricingList: {
    required: true,
  },
  region: {
    region: true,
  }
})
const route = useRoute()
const router = useRouter()
const paymentCycle = ref("1")
const loadingFlag = ref(true)


const emit = defineEmits(['close']);

function close() {
  emit('close')
}

// Computed functions to handle dynamic price plans
const getCurrentPricePlan = (item) => {
  return computed(() =>
      item.pricePlan.value.find((option) => option.key === paymentCycle.value)?.value || []
  );
};


</script>

<template>

  <section>
    <BaseDialog
        :size="'w-[95vw]'"
        staticBackdrop
        :open="show"
        :has-footer="true"
        :title="region.displayName"
        @close="close"
    >
      <div class="rounded-md px-2 py-2 w-full max-h-[78vh] overflow-auto mb-3">
        <div class="grid grid-cols-12 gap-3">
          <Tab.Group class="max-h-full col-span-12">
            <div class="top-0 pb-3 xl:sticky">
              <Tab.List
                  variant="pills"
                  class="mx-auto border border-dashed rounded-md border-slate-300 dark:border-darkmode-300"
              >
                <Tab v-for="value in ['1','3','6','12']" :key="value">
                  <Tab.Button
                      as="button"
                      class="w-full py-1.5 px-2"
                      :class="{ active: paymentCycle === value }"
                      @click="paymentCycle = value"
                  >
                    {{ value }} {{ $t('title.month') }}
                  </Tab.Button>
                </Tab>
              </Tab.List>
            </div>
          </Tab.Group>

          <div v-for="(item,index) in pricingList" :key="index"
               class="col-span-12 xl:col-span-4 md:col-span-6 lg:col-span-6 p-3 box shadow-md rounded-lg">
            <!-- Card Header -->
            <div class="text-base font-bold text-center mb-2">
              {{ item.assetName }} {{item.Network?.displayName}}
            </div>
            <!-- Table -->
            <table class="table-auto w-full border-collapse border border-gray-200 rounded-md">
              <thead class="bg-gray-100">
              <tr>
                <th class="border px-4 py-1">{{ $t("title.value") }}</th>
                <th class="border px-4 py-1">{{ $t("title.base-price") }}</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(plan, index) in getCurrentPricePlan(item).value"
                  :key="index"
              >
                <td class="border px-4 py-1 text-center text-xs">{{ plan.key }}</td>
                <td class="border px-4 py-2 text-center">
                  {{ plan.price }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </BaseDialog>
  </section>

</template>

<style scoped>
button {
  transition: all 0.3s ease;
}

button:hover {
  transform: scale(1.05);
}
</style>
